import React from 'react';
import { getFrontendURL } from 'src/utils/url';
import { SectionButtonDescriptor } from 'src/pages/OfferPage/DocuSectionButtons/docuSectionButtonDefs';
import { SetPropertyRequest, useSetProjectQuoteUserPropertyMutation } from 'src/api/v1/project-ApiSlice';
import { useParams } from 'react-router';

export const DropdownOptionButton =
    ({buttonDesc, color = 'black'}: {buttonDesc: SectionButtonDescriptor, color?: string}) => {

  const params = useParams<{ projectId: string }>();
  const [ updateProperty ] = useSetProjectQuoteUserPropertyMutation()

  const selectedVal = React.useMemo(() => {
    return buttonDesc.values!!.find((val: any) => {
      return val.value === buttonDesc.state
    });
  }, [buttonDesc]);

  const extra = (selectedVal && selectedVal.valueExtra) || buttonDesc.iconExtra;

  const isIconImg =
    typeof buttonDesc.icon === "string" &&
    (buttonDesc.icon.indexOf("/") === 0 || buttonDesc.icon.indexOf("http") === 0);

  return (
    <div
      className={`not-rounded quote-option-container ${buttonDesc.enabled ? "" : "disabled"}`}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pointerEvents: buttonDesc.enabled ? "auto" : "none",
        width: "270px",
      }}
    >
      <div
          style={{ position: "relative" }}
          className={`not-rounded`}
      >
        {isIconImg ? (
          <img
            src={getFrontendURL() + '/' + buttonDesc.icon}
            className={`not-rounded`}
            style={{
              height: 25,
              width: 25,
              objectFit: "contain",
            }}
          />
        ) : (
          <i
            style={{
              color: color,
              fontSize: 22,
              // lineHeight: "42px",
              height: 25,
              width: 25,
              textAlign: "center",
            }}
            className={selectedVal.icon || buttonDesc.icon}
          ></i>
        )}
        {extra ? (
          <i
            style={{ color: color }}
            className={`${extra} quote-button-bottomright`}
          ></i>
        ) : null}
      </div>
      {buttonDesc.label && <div style={{ paddingLeft: 10 }}>{buttonDesc.label}</div>}
      <div
        style={{
          paddingLeft: 10,
          width: "100%",
        }}
      >
        <select
            onChange={(e) => {
              let value: number|string = e.target.value;
              if (typeof (buttonDesc.values!![0].value) === 'number') {
                value = Number(value);
              }
              updateProperty({
                projectId: +(params.projectId!!),
                propertyKey: buttonDesc.propertyKey,
                value: value
              } as SetPropertyRequest)
            }
            }
          value={selectedVal.value}
          className="quote-option-select"
          style={{
            height: 35,
            width: "100%",
            borderWidth: 1,
            borderColor: color,
            borderRadius: "6px",
            backgroundColor: "transparent",
            fontSize: 16
          }}
        >
          {buttonDesc.values!!.map((x: any) => (
            <option disabled={!!x.disabled} key={x.value} value={x.value}>
              {x.text}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
